import { render } from "./ChatMessage.vue?vue&type=template&id=53dbcc93&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&lang=ts"

import "./ChatMessage.vue?vue&type=style&index=0&id=53dbcc93&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-53dbcc93"

export default script